import API from "../../api/api";
import Comments from "./Comments";
import JobDetails from "./JobDetails";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import "../../styles/css/Jobs/JobView.css";
import JobReviewCard from "./JobReviewCard";
import JobDetailsCard from "./JobDetailsCard";
import { Container, Row, Col } from "bootstrap-4-react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CircularProgress from "@material-ui/core/CircularProgress";

class JobView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobId: this.props.match.params.id,
      bidData: [],
      bidStartedDate: "",
      jobData: [],
      cardData: {},
      jobStatus: "",
      userComments: "",
      review: "",

      isDashboardLoading: true,
    };
  }

  componentDidMount() {
    API.post("job/survey/" + this.state.jobId)
      .then((res) => {
        const bid = res.data.response.bid;
        const bidStartedDate =
          "created_at" in res.data.response.bid
            ? res.data.response.bid.created_at.date.split(" ")[0]
            : "";
        const card = res.data.response.card;
        const job = res.data.response.job[0];
        const comments = res.data.response.comments;
        const review = res.data.response.review;

        this.setState({
          bidData: bid,
          jobData: job,
          cardData: card,
          bidStartedDate: bidStartedDate,
          userComments: comments,
          jobStatus: job.job_status,
          review: review,
          isDashboardLoading: false,
        });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  }

  render() {
    const { jobStatus, isDashboardLoading } = this.state;

    return (
      <div>
        {isDashboardLoading ? (
          <div className="preloader">
            <CircularProgress className="preloaderCircle" />
          </div>
        ) : (
          <div className="jobCreationMain">
            <Container className="breadCrubmContainerDashboard">
              <div className="breadCrumb">
                <Link to="/" className="prevLinks">
                  Dashboard
                </Link>
                <span>&nbsp;&gt;&nbsp;</span>
                <span className="currLink">{this.state.jobData.name}</span>
              </div>
            </Container>
            <div className="browseMain">
              <Container>
                <Row>
                  <Col col="sm-12 md-12 lg-3">
                    <div>
                      <JobDetailsCard
                        jobId={this.state.jobId}
                        cardData={this.state.cardData}
                        bidStartedDate={this.state.bidStartedDate}
                      />
                    </div>
                    {jobStatus === "Completed" && (
                      <div>
                        <JobReviewCard
                          review={this.state.review}
                          jobId={this.props.match.params.id}
                        />
                      </div>
                    )}
                  </Col>
                  <Col col="sm-12 md-12 lg-9">
                    {(jobStatus === "In-progress" ||
                      jobStatus === "Verify" ||
                      jobStatus === "Completed") && (
                      //comments

                      <div>
                        <div className="activeUsersDiv">
                          <span>Comments</span>
                          <ArrowDropDownIcon />
                        </div>
                        <Comments
                          jobId={this.state.jobId}
                          comments={this.state.userComments}
                        />
                      </div>
                    )}
                    <div>
                      <JobDetails
                        jobId={this.state.jobId}
                        jobData={this.state.jobData}
                        bidData={this.state.bidData}
                        cardData={this.state.cardData}
                      />
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default JobView;



// WEBPACK FOOTER //
// ./src/pages/Jobs/JobView.js